import { RootState } from '../index'

export const selectUsers = (state: RootState) => state.users.users
export const selectRoles = (state: RootState) => state.roles

export const selectAccount = (state: RootState) => state.auth.account
